import { Text } from '@tonic-one/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useUtcOffsetStore } from 'src/models/useUtcOffsetModel';
import { formatTableTopX } from 'src/utils/table';

import { useDashboardServicesStore } from '../../../../models/useDashboardServicesModel';
import { ThreatType } from '../../../../utils/enums';
import { getServiceNamesByValues } from '../../../../utils/service';
import { generateRedirectUrlToLog } from '../../../Log/shared';
import TableTemplate from '../../Charts/TableTemplate';
import DashboardCard from '../../Layout/DashboardCard';
import RedirectLink from '@Components/RedirectLink';
import { LogTypeEnum, SecurityFilterName } from '@Types/log';

function VirtualAnalyzerAffectedByURL(props: { data: any; day: string }) {
  const { t } = useTranslation();
  const timeModel = useUtcOffsetStore();
  const servicesModel = useDashboardServicesStore();
  const config = [
    { width: '30%', grow: 2, align: 'left', tooltip: true },
    { width: '15%', grow: 0, align: 'right' },
    { width: '20%', grow: 1, align: 'left', tooltip: true },
  ];
  const header = [
    t('dashboard.chart.column.user'),
    t('dashboard.chart.column.detections'),
    t('dashboard.chart.column.lastDetected'),
  ];

  const data: any = formatTableTopX(
    props.data?.virtual_analyzerTopAffectedRecipients?.URL?.[props.day],
    ['key', 'doc_count', 'tm_timestamp'],
    t,
    timeModel.offset
  );
  if (data && data.length > 0) {
    data.forEach((item: any, index: number) => {
      data[index][1] =
        data[index][1] === 0 ? (
          0
        ) : (
          <RedirectLink
            href={`logs?${generateRedirectUrlToLog(
              [
                {
                  field: 'threatType',
                  values: [
                    ThreatType.MaliciousURL,
                    ThreatType.MaliciousFile,
                    ThreatType.Ransomware,
                  ],
                  type: 'terms',
                },
                {
                  field: 'securityFilterName',
                  values: [SecurityFilterName.VirtualAnalyzer],
                  type: 'terms',
                },
                {
                  field: 'violator',
                  values: [data[index][0] as string],
                  type: 'terms',
                },
                {
                  field: 'ddaaasScanType',
                  values: ['URL'],
                  type: 'terms',
                },
                // {
                //   field: 'fileSHA1',
                //   values: [data[index][0] as string],
                //   type: 'terms',
                // },
                {
                  field: 'scanSource',
                  values: getServiceNamesByValues(
                    servicesModel.enabledServices
                  ),
                  type: 'terms',
                },
              ],
              props.day,
              LogTypeEnum.DETECTION
            )}`}
          >
            <Text>{data[index][1]}</Text>
          </RedirectLink>
        );
    });
  }
  return (
    <DashboardCard
      title={t('dashboard.chart.title.virtualAnalyzerAffectedByURL')}
    >
      <TableTemplate config={config} header={header} data={data} />
    </DashboardCard>
  );
}
export default React.memo(VirtualAnalyzerAffectedByURL);
